<template>
  <div class="home w-100 container">

    <div class="justify-content-center">
        <h3 class="text-center">OnePathLife Brochures</h3>
        <h4 class="text-center mt-5">Download OnePathLife Brochures</h4>

        <div class="row mt-5 justify-content-center">
        <div class="col-md-3">
            <img src="../assets/Assurance-Extra-Life-and-Life-and-Income.jpg" class="img-thumbnail" alt="img1" />
            <a href="#" v-on:click="openFile('a3702-assurance-extra-life---life-income-cover-1574839450')"><h4>Click here to download</h4></a>
        </div>
        <div class="col-md-3">
            <img class="img-thumbnail" src="../assets/Assurance-Extra-Trauma.jpg" alt="img2" />
            <a href="#" v-on:click="openFile('a3703-assurance-extra-trauma-cover')"><h4>Click here to download</h4></a>
        </div>
        <div class="col-md-3">
            <img class="img-thumbnail" src="../assets/Assurance-Extra-Income-Cover.jpg" alt="img3" />
            <a href="#" v-on:click="openFile('a3706-assurance-extra-income-cover')"><h4>Click here to download</h4></a>
        </div>
        </div>
        <div class="row mt-5 justify-content-center">
        <div class="col-md-3">
            <img class="img-thumbnail" src="../assets/Assurance-Extra-Mortgage-Repayment.jpg" alt="img4" />
            <a href="#" v-on:click="openFile('a3707-assurance-extra-mortgage-repayment-cover')"><h4>Click here to download</h4></a>
        </div>
        <div class="col-md-3">
            <img class="img-thumbnail" src="../assets/Assurance-Extra-Redundancy.jpg" alt="img5" />
            <a href="https://www.cigna.co.nz/insurance-products" target="_brank"><h4>Click here to download</h4></a>
        </div>
        <div class="col-md-3">
            <img class="img-thumbnail" src="../assets/Assurance-Extra-Complete-Disablement.jpg" alt="img6" />
            <a href="#" v-on:click="openFile('a3704-assurance-extra-complete-disablement-cover')"><h4>Click here to download</h4></a>
        </div>
        </div>
        <div class="row mt-5 justify-content-center">
        <div class="col-md-3">
            <img class="img-thumbnail" src="../assets/Assurance-Extra-Premium.jpg" alt="img7" />
            <a href="#" v-on:click="openFile('a3708-assurance-extra-premium-cover')"><h4>Click here to download</h4></a>
        </div>

        </div>
    </div>
  

  </div>
</template>

<script>
// @ is an alias to /src
import {mapState,mapMutations} from 'vuex'
import axios from 'axios'
export default {
  name: 'OnePath',
  data(){
    return{
      
    }
  },
  components: {
  },
  computed:{
   ...mapState(['token'])
  },
  methods:{
      ...mapMutations(['setLogIn','checkLogIn']),      
      openFile(name){
        axios('gafa.co.nz/assets/onepath_pdf/'+name+'.pdf', {
            method: 'GET',
            responseType: 'blob'
        })
        .then(response => {
            //Create a Blob from the PDF Stream
            const file = new Blob(
            [response.data], 
            {type: 'application/pdf'});
            //Build a URL from the file
            const fileURL = URL.createObjectURL(file);
            //Open the URL on new Window
            window.open(fileURL);
        })
        .catch(error => {
            console.log(error);
        });
      }    
  },
  created(){
  
      
  }
}
</script>
<style>
    img{
    max-width: 200px!important;
    }
    .container {
    background-color: var(--Color-main-gray-1);
    width:20%;
    margin:auto;
    padding:15px;
    border-radius: 10px;
    }
</style>